import { InformationSlabBoxOutlineIcon } from './InformationSlabBoxOutlineIcon';

/**
 * author: Jeff Anders
 * id 996F0E18-7078-44A0-A0DC-F2A829210F07
 * name information-slab-box-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-slab-box-outline.svg
 * tags
 * - Settings 
 */
export const InfoSlabBoxOutlineIcon = InformationSlabBoxOutlineIcon;
export default InfoSlabBoxOutlineIcon